import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from '@app/store';

const SUPPORT_AGENT_GROUPS = [
  'Support',
  'Support - Dev-Ops',
  'Support - Jira',
  'Support - Tech Support',
  'Support - Triage',
  '1. Bank:: Front Office - Support',
];

export interface IAuthState {
  token: string | null;
  currentUser: any;
  isSupportUser: boolean;
  // Set when the session can't be renewed or the API returns 401. AppRouter then
  // clears the stored session and shows the Sign In screen, instead of letting
  // the library redirect the Zendesk iframe itself.
  sessionExpired: boolean;
}

const initialState: IAuthState = {
  token: null,
  currentUser: JSON.parse(sessionStorage.getItem('current-user') || 'null'),
  isSupportUser: sessionStorage.getItem('is-current-user-support') === 'true',
  sessionExpired: false,
};

export const selectToken = (state: IRootState) => state.auth.token;

export const selectIsAuthenticated = (state: IRootState) => !!state.auth.token;

export const selectIsSupportUser = (state: IRootState) =>
  state.auth.isSupportUser;

export const selectSessionExpired = (state: IRootState) =>
  state.auth.sessionExpired;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    setCurrentUser: (state, action: PayloadAction<any>) => {
      const currentUser = action.payload;

      sessionStorage.setItem('current-user', JSON.stringify(currentUser));
      state.currentUser = currentUser;
      //
      const isSupportUser = currentUser?.groups?.some(
        (group: { name: string }) => SUPPORT_AGENT_GROUPS.includes(group.name)
      );

      state.isSupportUser = isSupportUser;
      sessionStorage.setItem(
        'is-current-user-support',
        isSupportUser ? 'true' : 'false'
      );
    },
    setIsSupportUser: (state, action: PayloadAction<boolean>) => {
      state.isSupportUser = action.payload;
      sessionStorage.setItem(
        'is-current-user-support',
        state.isSupportUser ? 'true' : 'false'
      );
    },
    setSessionExpired: (state, action: PayloadAction<boolean>) => {
      state.sessionExpired = action.payload;
    },
  },
});

export const { setToken, setCurrentUser, setIsSupportUser, setSessionExpired } =
  authSlice.actions;

export default authSlice.reducer;
